import Text from "components/general/Text";
import {
    IoMdInformationCircleOutline,
    IoMdCloseCircleOutline,
    IoMdCheckmarkCircleOutline,
} from "react-icons/io";
import styles from "./styles.module.scss";
import { IoAlertCircleOutline } from "react-icons/io5";

export type InfoCardVariant = "info" | "warning" | "error" | "success";

interface InfoCardProps {
    title: string;
    description: string;
    variant?: InfoCardVariant;
}

const variantConfig = {
    info: {
        icon: IoMdInformationCircleOutline,
        color: "#3b82f6",
        className: styles.info,
    },
    warning: {
        icon: IoAlertCircleOutline,
        color: "#f59e0b",
        className: styles.warning,
    },
    error: {
        icon: IoMdCloseCircleOutline,
        color: "#ef4444",
        className: styles.error,
    },
    success: {
        icon: IoMdCheckmarkCircleOutline,
        color: "#10b981",
        className: styles.success,
    },
};

export default function InfoCard({ title, description, variant = "info" }: InfoCardProps) {
    const config = variantConfig[variant];
    const Icon = config.icon;

    return (
        <div className={`${styles.infoCard} ${config.className}`}>
            <Icon size={32} color={config.color} className={styles.icon} />
            <div className={styles.infoContent}>
                <Text className={styles.infoTitle}>{title}</Text>
                <Text className={styles.infoDesc}>{description}</Text>
            </div>
        </div>
    );
}
